import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { AuthUser, AccessKind } from '@/types'
import { authService } from '@/services/auth.service'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<AuthUser | null>(null)
  const loaded = ref(false)

  const isAuthenticated = computed(() => user.value !== null)

  async function load() {
    if (loaded.value) return
    user.value = await authService.me()
    loaded.value = true
  }

  async function logout() {
    try {
      await authService.logout()
    } finally {
      user.value = null
    }
  }

  function has(kind: AccessKind): boolean {
    const u = user.value
    if (!u) return false
    if (kind === 'admin') return u.isAdmin
    if (kind === 'dashboard') return u.dashboardAccess
    return u.renewalsAccess
  }

  return { user, loaded, isAuthenticated, load, logout, has }
})
